<!--suppress ALL -->
<template>
    <div class="slide" v-on:mouseover="stop()" v-on:mouseout="move()">
        <div class="slideshow" ref="fdDiv" :style="{height:initHeight+'px'}">
            <transition-group tag="ul" name="image">
                <li v-for="(img, index) in imgArray" v-show="index===mark" :key="index">
                    <a href="#">
                        <img :src='img'>
                    </a>
                </li>
            </transition-group>
        </div>
        <div class="bar" >
      <span v-for="(item, index) in imgArray" :class="{ 'active':index===mark }"
            @click="change(index)" :key="index"></span>
        </div>
    </div>
</template>
<script>
    export default {
        name: "test",
        data () {
            return {
                showPrise:true,
                timer: null, //定时器
                mark: 0, //比对图片索引的变量
                imgArray: [//图片路径
                    require('../img2/spf/xingye.png'),
                    require('../img2/spf/xueyan.png'),
                    require('../img2/spf/lvju.png'),
                    require('../img2/spf/lunbo2.png'),
                ],
                initHeight:(window.screen.width)*577/1920,
            }
        },
        methods: {
            autoPlay () {
                this.mark++;
                if (this.mark == this.imgArray.length) {
                    this.mark = 0;
                }
            },
            play () {
                this.timer = setInterval(this.autoPlay, 4000)
            },
            change (i) {
                this.mark = i
            },
            stop () {
                clearInterval(this.timer)
            },
            move () {
                this.timer = setInterval(this.autoPlay, 4000)
            },
        },
        created () {
            this.play();
            if(this.$route.query.id=="/ywhome/clfhome"){
                this.showPrise=true;
            }else{
                this.showPrise=false;
            }
        }
    }
</script>


<style scoped>
    /** {
        margin: 0;
        padding: 0;
        list-style: none;
    }*/
    .slide {
        width: 100%;
        margin: 0 auto;
        overflow: hidden;
        position: relative;
    }
    .slideshow {
        width: 100%;
    }
    .slideshow ul{
        width:100%;
    }
    li {
        width:100%;
        position: absolute;
    }
    .slideshow ul a{
        display: inline-block;
        width:100%;
    }
    li a img {
        width: 100%;
    }
    .bar {
        position: absolute;
        width: 100%;
        bottom: 10px;
        margin: 0 auto;
        z-index: 10;
        text-align: center;
    }
    .bar span {
        width: 10px;
        height: 10px;
        border-radius:50%;
        background: white;
        display: inline-block;
        margin-right: 10px;
    }
    .active {
        background: #3273F6 !important;
    }
    .image-enter-active {
        transform: translateX(0);
        transition: all 1.5s ease;
    }
    .image-leave-active {
        transform: translateX(-100%);
        transition: all 1.5s ease;
    }
    .image-enter {
        transform: translateX(100%);
    }
    .image-leave {
        transform: translateX(0);
    }
    .v-application ul, .v-application ol {
         padding-left: 0px;
    }
</style>
<style>
    /*@media screen and (max-width: 414px) {
        .clfInput {
            position: absolute;
            bottom: 20px;
        }
    }
    @media screen and (min-width: 414px) {
        .clfInput {
            width: 100%;
            position: absolute;
            bottom: 40px;
        }
        .ssInput .el-input__inner{
            height: 64px;
            margin: auto;
        }
    }*/
</style>